import React from 'react';

const FinalChecklist = () => {
  return (
    <div className="tips-section">
      <h3>📋 Final Checklist</h3>
      <ul>
        <li>All required documents uploaded and approved</li>
        <li>Documents are less than 3 months old</li>
        <li>Passport valid for at least 6 months</li>
        <li>Appointment scheduled at embassy</li>
        <li>Application fee paid (keep receipt)</li>
        <li>Print 2 copies of each document</li>
      </ul>
    </div>
  );
};

export default FinalChecklist;